import type { ReactNode } from "react";
import { SyncStatus } from "@/components/shared/SyncStatus";
import { MobileTabBar } from "./MobileTabBar";

export function MobileShell({
  children,
  showTabs = true,
}: {
  children: ReactNode;
  showTabs?: boolean;
}) {
  return (
    <div
      style={{
        width: "100%",
        height: "100dvh",
        background: "var(--bg)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "calc(env(safe-area-inset-top, 0px) + 8px)",
          right: 12,
          zIndex: 40,
          pointerEvents: "none",
        }}
      >
        <SyncStatus degradedOnly />
      </div>
      <div
        style={{ flex: 1, overflowY: "auto", paddingBottom: showTabs ? 80 : 0 }}
      >
        {children}
      </div>
      {showTabs && <MobileTabBar />}
    </div>
  );
}
